import React from "react";
import { useModals } from "@/lib/modal-context";

const WhatsIcon = ({ className = "w-5 h-5" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
        <path d="M19.05 4.91A9.83 9.83 0 0 0 12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.74.46 3.45 1.32 4.95L2 22l5.25-1.38a9.86 9.86 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.91-7.02Zm-7 15.19h-.01a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3.12.82.83-3.04-.19-.31a8.1 8.1 0 0 1-1.24-4.36c0-4.49 3.66-8.14 8.16-8.14 2.18 0 4.22.85 5.76 2.39a8.07 8.07 0 0 1 2.39 5.76c-.01 4.49-3.66 8.19-8.15 8.19Zm4.47-6.1c-.24-.12-1.45-.72-1.67-.8-.22-.08-.39-.12-.55.12-.16.24-.63.8-.78.96-.14.16-.29.18-.53.06-.24-.12-1.03-.38-1.97-1.21-.73-.65-1.22-1.45-1.36-1.69-.14-.24-.02-.37.11-.49.11-.11.24-.29.37-.43.12-.14.16-.24.24-.41.08-.16.04-.31-.02-.43-.06-.12-.55-1.33-.76-1.81-.2-.48-.4-.42-.55-.42-.14-.01-.31-.01-.47-.01a.91.91 0 0 0-.66.31c-.22.24-.86.84-.86 2.05s.88 2.38 1 2.54c.12.16 1.74 2.66 4.21 3.73.59.26 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.45-.59 1.66-1.16.21-.57.21-1.06.14-1.16-.06-.1-.22-.16-.46-.28Z"/>
    </svg>
);

export default function FloatingWhatsApp() {
    const { openConnect } = useModals();
    return (
        <button
            data-testid="floating-whatsapp"
            onClick={() => openConnect()}
            className="fixed bottom-5 right-5 z-50 btn-pill btn-lime shadow-xl"
            aria-label="Connect on WhatsApp"
        >
            <span className="hidden sm:inline text-sm font-bold">Connect In 15 Secs</span>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-black text-[#CCFF00]">
                <WhatsIcon className="h-5 w-5" />
            </span>
        </button>
    );
}
